// client/src/pages/Home.tsx
import { FormEvent, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import CreateListSheet from '@/components/CreateListSheet';
import { CODE_RE, toSlugForBackend } from '@/utils/code';

export default function Home() {
  const nav = useNavigate();
  const [codeInput, setCodeInput] = useState('');
  const [err, setErr] = useState<string>('');
  const [createOpen, setCreateOpen] = useState(false);

  function onSubmit(e: FormEvent) {
    e.preventDefault();
    setErr('');
    const raw = codeInput.trim();
    if (!CODE_RE.test(raw)) {
      setErr('Use 4–12 letters or digits.');
      return;
    }
    const slug = toSlugForBackend(raw);
    if (!slug) {
      setErr('Code becomes empty after sanitizing.');
      return;
    }
    nav(`/${encodeURIComponent(slug)}`);
  }

  return (
    <main id="app" role="main" aria-labelledby="landing-title">
      <a className="skip-link" href="#maincontent">Skip to content</a>
      <span id="maincontent" className="sr-only">Main content</span>

      <section id="landing-view" className="view" aria-labelledby="landing-title">
        <div className="panel glass" role="region" aria-label="Access panel">
          <h1 id="landing-title">My Events</h1>
          <p className="lede">Spin up a lightweight, shareable calendar in seconds. Viewers just need a code; editors unlock with a password.</p>

          <ul className="feature-list" aria-label="Highlights">
            <li>Unlimited lists — each with its own access code</li>
            <li>Drag-and-drop ordering or automatic by date</li>
            <li>Works offline, installs like an app, exports to calendar</li>
          </ul>

          <form className="code-form" onSubmit={onSubmit} noValidate>
            <div className="input-row">
              <div className="field">
                <label htmlFor="access-code">Access code</label>
                <input
                  id="access-code"
                  name="access-code"
                  type="text"
                  inputMode="text"
                  placeholder="e.g., FAMILY24"
                  aria-describedby="code-help code-error"
                  required
                  maxLength={12}
                  value={codeInput}
                  onChange={(e) => setCodeInput(e.target.value)}
                />
                <div id="code-help" className="help">Share a short code (4–12 letters or digits) to open an existing list.</div>
                <div id="code-error" className="error" role="alert" aria-live="polite">{err}</div>
              </div>
            </div>

            <div className="actions">
              <button type="button" className="btn" onClick={() => setCreateOpen(true)}>
                Create a new list
              </button>
              <button type="submit" className="btn primary" id="view-events-btn">
                View events
              </button>
            </div>
          </form>
        </div>
      </section>

      <CreateListSheet open={createOpen} onClose={() => setCreateOpen(false)} />
    </main>
  );
}
